/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 7/25/13
 * Time: 9:45 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    require('ams-client/AMSClientV2');

    require('web-agent-plugins/ConfigurationPlugin');
    require('web-agent-plugins/ShortcutsPlugin');
    require('web-agent-plugins/DialogsPlugin');
    require('web-agent-plugins/TranslatorPlugin');
    require('web-agent-plugins/ModelPlugin');
    require('web-agent-plugins/LoggerPlugin');
    require('web-agent-plugins/LiveEngagePlugin');
    require('web-agent-plugins/TimerPlugin');
    require('web-agent-plugins/SanitizePlugin');
    require('web-agent-plugins/UtilsPlugin');

    require('web-agent-assets-js/Application');

    var LE = require("app");
    var CONST = require("const");
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var WebAgentRouteController = require("web-agent-controllers/WebAgentRouteController");
    var Application = require('web-agent-assets-js/Application');

    LE.module('LEWebAgent', function (LEWebAgent) {
        window.lpTag = window.lpTag || {};
        window.lpTag.WebAgent = window.lpTag.WebAgent || {};

        var initializer = {
            container:null,
            initMethod:null,
            initialized:false,
            initWebAgent:function () {
                if (!this.initialized && this.container && this.initMethod) {
                    var token = LE.sessionManager.getGlob();
                    var account = LE.sessionManager.getAccountId();
                    var domain = LE.urlResolver.getConfigValue("adminArea");
                    var environment = (domain && domain.indexOf('hc1') !== -1) ? "QA" : void 0;

                    this.initMethod({
                        view:this.container,
                        accessToken:token,
                        account:account,
                        environment:environment,
                        domain:domain,
                        keepAliveMethod:LEWebAgent.touchSession,
                        logoutMethod:LEWebAgent.logout,
                        revalidateSession:LEWebAgent.revalidateSession,
                        authError:{
                            types:CONST.AUTH_ERROR,
                            method:LEWebAgent.triggerAuthError
                        }
                    });
                    this.initialized = true;
                }
            }
        };

        LE.vent.on("webAgent:ready", function () {
            initializer.initMethod = Application.initApplication;

            initializer.initWebAgent();
        });

        LE.vent.on("LERegion:LEWebAgent:ready", function (options) {
            initializer.container = options.region.$el[0];

            initializer.initWebAgent();
        });

        LE.soundController.on("change", function() {
            if (lpTag.WebAgent.soundManager) {
                lpTag.WebAgent.soundManager.toggleSounds();
            }
        });

        LEWebAgent.addInitializer(function () {
            LEWebAgent.viewController = new WebAgentRouteController();
        });

        LEWebAgent.on("start", function (options) {

        });

        LEWebAgent.on("stop", function (options) {
            lpAgent.agent.sessionEnded();
        });

        LEWebAgent.on("signout", function (options) {
            // notify the agent to kill Agent Session with the appServer
            lpAgent.agent.sessionEnded(true);
        });

        LEWebAgent.getMainView = function () {
            return LEWebAgent.viewController.getMainView();
        };

        LEWebAgent.getRouteController = function () {
            return LEWebAgent.viewController;
        };

        LEWebAgent.getLeaveConfirmationText = function (isSignOut) {
            var signoutWarning = lpTag.WebAgent.logicController.hasMessagingFeature() ? window.LE.translator.translate("LEWebAgent.signoutWarningAsyncMessaging") : window.LE.translator.translate("LEWebAgent.signoutWarning");
            return isSignOut ? signoutWarning : window.LE.translator.translate("LEWebAgent.navigateAwayWarning");
        };
    });

    LE.vent.trigger("webAgent:ready");

    return LE.module("LEWebAgent");
});
